export const Routes = {
  // authen
  Signin: { path: "/login-in" },
  Signup: { path: "/sign-up" },
  ForgotPassword: { path: "/forgot-password" },
  ResetPassword: { path: "/reset-password" },
  ServerError: { path: "/server-error" },

  // trang chủ
  Overview: { path: "/" },
  NotificationManagement: { path: "/notification-management" },
  CustomerOverview: { path: "/customer" },
  SettingOverview: { path: "/setting" },
  DeviceManagementOverview: { path: "/device-management" },
  DeviceManagementDevices: { path: "/device-management/devices" },
  DeviceManagementEmployees: { path: "/device-management/employees" },
  DeviceManagementAdmins: { path: "/device-management/admins" },
  DeviceManagementPrintQueue: { path: "/device-management/print-queue" },
  VietlottOverview: { path: "/vietlott" },
  ClassicOverview: { path: "/classic" },
  LotoOverview: { path: "/loto" },
  LotoThudoOverview: { path: "/loto-thudo" },

  // CUSTOMER
  CustomerAddChargeApp: { path: "/customer/charge/app" },
  CustomerChargeHistoryApp: { path: "/customer/charge/history-app" },
  CustomerAddChargeWeb: { path: "/customer/charge/web" },
  CustomerChargeHistoryWeb: { path: "/customer/charge/history-web" },
  CustomerCashbackHistoryWeb: { path: "/customer/charge/cashback-history-web" },
  CustomerIssueCharge: { path: "/customer/charge/issue-charge" },
  CustomerChargeSummary: { path: "/customer/charge/summary" },
  CustomerChargeList: { path: "/customer/charge/list" },
  CustomerRefundApp: { path: "/customer/refund/app" },
  CustomerRefundHistoryApp: { path: "/customer/refund/history-app" },
  CustomerRefundWeb: { path: "/customer/refund/web" },
  CustomerRefundHistoryWeb: { path: "/customer/refund/history-web" },
  CustomerWithdrawRequestApp: { path: "/customer/withdraw/app" },
  CustomerWithdrawRequestAppConfirmed: {
    path: "/customer/withdraw/app-confirmed",
  },
  CustomerWithdrawRequestWeb: { path: "/customer/withdraw/web" },
  CustomerWithdrawRequestWebConfirmed: {
    path: "/customer/withdraw/web-confirmed",
  },
  CustomerWithdrawSummaryApp: { path: "/customer/withdraw/summary-app" },
  CustomerWithdrawSummaryWeb: { path: "/customer/withdraw/summary-web" },
  CustomerUser: { path: "/customer/account/user" },
  CustomerTransactionHistory: { path: "/customer/account/transaction-history" },
  CustomerCashFlow: { path: "/customer/account/cash-flow" },
  CustomerNewUserSummary: { path: "/customer/new-user-summary" },

  // VIETLOTT
  VietlottCart: { path: "/vietlott/search/cart" },
  VietlottTicket: { path: "/vietlott/search/ticket" },
  VietlottKenoResult: { path: "/vietlott/result/keno" },
  VietlottPowerResult: { path: "/vietlott/result/power" },
  VietlottMegaResult: { path: "/vietlott/result/mega" },
  VietlottLotto535Result: { path: "/vietlott/result/lotto535" },
  VietlottMax3dResult: { path: "/vietlott/result/max3d" },
  VietlottMax3dProResult: { path: "/vietlott/result/max3d-pro" },
  VietlottRewardCalcJob: { path: "/vietlott/reward-calc-job" },
  VietlottRewardCalcSetting: { path: "/vietlott/reward-calc-setting" },
  VietlottReward: { path: "/vietlott/reward" },
  VietlottBigReward: { path: "/vietlott/reward/big-reward" },
  VietlottCurrentPeriod: { path: "/vietlott/period/current-period" },
  VietlottDayOff: { path: "/vietlott/period/day-off" },
  VietlottKenoPeriod: { path: "/vietlott/period/keno-period" },
  VietlottPowerPeriod: { path: "/vietlott/period/power-period" },
  VietlottMegaPeriod: { path: "/vietlott/period/mega-period" },
  VietlottLotto535Period: { path: "/vietlott/period/lotto535-period" },
  VietlottMax3dPeriod: { path: "/vietlott/period/max3d-period" },
  VietlottMax3dProPeriod: { path: "/vietlott/period/max3d-pro-period" },

  // CLASSIC
  ClassicListReward: { path: "/classic-common/list-reward" },
  ClassicRegion: { path: "/classic-common/region" },
  ClassicMNChannel: { path: "/classic/mn/channel" },
  ClassicMTChannel: { path: "/classic/mt/channel" },
  ClassicMBChannel: { path: "/classic/mb/channel" },
  ClassicChannelCombined: { path: "/classic/channel" },
  ClassicRewardCalcSetting: { path: "/classic/reward-calc-setting" },
  ClassicTicketInput: { path: "/classic/ticket-input" },
  ClassicPeriodCombined: { path: "/classic/period" },
  ClassicMNTicketInput: { path: "/classic/mn/ticket-input" },
  ClassicMTTicketInput: { path: "/classic/mt/ticket-input" },
  ClassicMNTicketSales: { path: "/classic/mn/ticket-sales" },
  ClassicMTTicketSales: { path: "/classic/mt/ticket-sales" },
  ClassicMBTicketSales: { path: "/classic/mb/ticket-sales" },
  ClassicTicketSalesCombined: { path: "/classic/ticket-sales" },
  ClassicMNReward: { path: "/classic/mn/reward" },
  ClassicMTReward: { path: "/classic/mt/reward" },
  ClassicMBReward: { path: "/classic/mb/reward" },
  ClassicReward: { path: "/classic/reward" },
  ClassicCart: { path: "/classic-track/cart" },
  ClassicTicket: { path: "/classic/ticket" },
  ClassicResult: { path: "/classic/result" },
  ClassicTicketStorage: { path: "/classic/ticket-storage" },
  ClassicStatistic: { path: "/classic/statistic" },
  ClassicStatisticByTicket: { path: "/classic/statistic-by-ticket" },
  ClassicStatisticByUnmarketableTicket: {
    path: "/classic/statistic-by-unmarketable-ticket",
  },
  ClassicMNPeriod: { path: "/classic/mn/period" },
  ClassicMTPeriod: { path: "/classic/mt/period" },
  ClassicMBPeriod: { path: "/classic/mb/period" },
  ClassicMNNewCart: { path: "/classic/mn/new-cart" },
  ClassicMTNewCart: { path: "/classic/mt/new-cart" },
  ClassicMBNewCart: { path: "/classic/mb/new-cart" },
  ClassicMNDoneCart: { path: "/classic/mn/done-cart" },
  ClassicMTDoneCart: { path: "/classic/mt/done-cart" },
  ClassicMBDoneCart: { path: "/classic/mb/done-cart" },
  ClassicOrder: { path: "/classic/order" },
  ClassicSearch: { path: "/classic/classic/search" },
  ClassicTicketReturn: { path: "/classic/ticket-return" },
  ClassicUnmarketableTickets: { path: "/classic/unmarketable-tickets" },

  // LOTO
  LotoChannel: { path: "/loto/channel" },
  LotoPeriod: { path: "/loto/period" },
  LotoCart: { path: "/loto/cart" },
  LotoReward: { path: "/loto/reward" },
  LotoStatisticByTicket: { path: "/loto/statistic-by-ticket" },
  LotoSetting: { path: "/loto/setting" },
  LotoRewardCalcSetting: { path: "/loto/reward-calc-setting" },
  LotoThudoPeriod: { path: "/loto-thudo/period" },
  LotoThudoStatisticByTicket: { path: "/loto-thudo/statistic-by-ticket" },

  // SETTING
  SettingDevices: { path: "/setting/devices" },
  SettingGames: { path: "/setting/games" },
  SettingBanner: { path: "/setting/banner" },
  SettingPaymentMethod: { path: "/setting/payment-method" },
  SettingAccount: { path: "/setting/account" },
  SettingBank: { path: "/setting/bank" },
  SettingNotification: { path: "/setting/notification" },
  SettingZalo: { path: "/setting/zalo-otp" },
  SettingPrivacy: { path: "/setting/privacy" },
  SettingGameGuide: { path: "/setting/game-guide" },
  SettingContact: { path: "/setting/contact" },
  SettingInvite: { path: "/setting/invite" },
  SettingSystemNotification: { path: "/setting/system-notification" },
  SettingMaintained: { path: "/setting/maintained" },
  SettingEmployee: { path: "/setting/employee" },
  SettingPrintQueue: { path: "/setting/print-queue" },
  SettingFee: { path: "/setting/fee" },
  SettingCrawler: { path: "/setting/crawler" },
  SettingDepositWithdraw: { path: "/setting/deposit-withdraw" },
  SettingSePay: { path: "/setting/sepay" },
  SettingSePayTransactions: { path: "/setting/sepay/transactions" },
  SettingHandoverDocs: { path: "/setting/tai-lieu-he-thong" },

  // ANOTHER
  MBRefund: { path: "/management/mb-refund" },
  MBDoisoat: { path: "/management/mb-doisoat" },
  NotFound: { path: "/not-found" },
};
